export default __webpack_public_path__ + "static/esg-3af1bacebd4c24be5ea45b3492c7d4bc.png";